// Casl enums used for subject FaResolving
// Should not be translated or changed
// Permissions checking depends on subjects defined in customer-admin

export const caslEnums = Object.freeze({
  manageAccessRights: 'Access Rights',
  objectCrud: 'Objects',
  nodeSecurityClassification: 'Node Security Classification',
  structuredDataEntities: 'Structured data entities',
});
